import { get, postJson, putJson, del } from '../httpClient';

export const sendbirdAPI = {
  // Get session token for current user
  // options.profileUrl - Optional profile URL to use for this session (context-specific avatar)
  getToken: (options = {}) => postJson('/api/sendbird/token', options),

  // Unread badge counts from our server, without connecting to Sendbird
  getUnreadCounts: () => get('/api/sendbird/unread-counts'),

  // Channel CRUD
  createChannel: body => postJson('/api/sendbird/channels', body),
  getChannels: params => get('/api/sendbird/channels', params),
  updateChannel: (channelUrl, body) => putJson(`/api/sendbird/channels/${encodeURIComponent(channelUrl)}`, body),

  // Channel members
  addMembers: (channelUrl, userIds) => postJson(`/api/sendbird/channels/${encodeURIComponent(channelUrl)}/members`, { userIds }),
  removeMember: (channelUrl, memberId) => del(`/api/sendbird/channels/${encodeURIComponent(channelUrl)}/members/${memberId}`),

  // Auto-join episode channel after booking
  joinEpisodeChannel: body => postJson('/api/sendbird/join-episode-channel', body),

  // Send admin/system message to a channel
  sendAdminMessage: body => postJson('/api/sendbird/admin-message', body),
};
